import { getActiveIframe } from '../state/activeIframe'
import { sendMessage } from '../../common/message/sendMessage'
import { IDPayloadAction } from '../../api/actions/helpers/createIDAction'

export const sendIDMessage = ({ action }: { action: IDPayloadAction }) => {
  const activeIframe = getActiveIframe()

  if (activeIframe) {
    sendMessage({
      action,
      windowElement: activeIframe.contentWindow ?? null,
    })
  }

  sendMessage({
    action,
  })
}
